/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Swal from 'sweetalert2';

import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import PanelSidebar from '../components/panel/PanelSidebar';
import {
  appendScript,
  removeScript,
  scrollToTopAnimated,
} from '../components/utils';
import ROUTES from '../data/routes';

import { history } from '../routers/AppRouter';

import {
  cartsGetListToApprove,
  cartApproveRemove,
  cartApproveSelect,
  copyCartCanceled,
  cartApproveApprove,
  approveCartAll,
  reproveCartAll,
} from '../app/store/actions/cart';

import { selectContract } from '../app/store/actions/contracts';

import purchaseData from '../data/purchases';
import PriceComponent from '../components/price/Price';
import PriceTaxComponent from '../components/price/PriceTax';
import CartUtils from '../app/utils/cart';

class cartsToApprovePage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      carts: [],
      cart: null,
      showModal: false,
      showModalCanceled: false,
      showModalApprove: false,
      showModalReprove: false,
      multi: false,
      filterBy: purchaseData.cartOrderTypes.AWAITING_APPROVAL.value,
      cartId: null,
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      if (!this.props.cartUsersPermission) {
        history.push(ROUTES.HOME);
        return;
      }

      await this.loadCarts();

      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');

      scrollToTopAnimated();
    }, 0);
  };

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  };

  loadCarts = async (selectValue) => {
    const { filterBy } = this.state;
    if (selectValue) {
      await this.setState({
        filterBy: selectValue,
      });
    }

    const carts = await this.props.getCarts(selectValue || filterBy);

    carts.forEach((cart) => {
      cart.selected = false;
    });

    await this.setState({ carts });
  };

  removeCart = async () => {
    const { cart = {} } = this.state;
    this.setState({ showModalReprove: false, multi: false, cart: null });
    await this.props.removeCart(cart.cartId);
    await this.loadCarts(null);
  };

  approveCart = async () => {
    const { cart = {} } = this.state;
    this.setState({ showModalApprove: false, cart: null, multi: false });
    await this.props.approveCart(cart.cartId);
    await this.loadCarts(null);
  };

  selectCart = async () => {
    const { cart } = this.state;
    const { contracts, contractSelected } = this.props;

    if (cart) {
      const index = contracts.list.findIndex(
        c => c.clientId === cart.clientId,
      );

      if (contractSelected && contractSelected.index !== index) {
        await this.props.selectContract(index);
      }

      await this.props.selectCart(cart.products, cart.cartId, cart.user, {
        addressCep: cart.addressCep,
        addressName: cart.addressName,
        addressWithdraw: cart.addressWithdraw,
        addressWithdrawLocker: cart.addressWithdrawLocker,
      });

      history.push(ROUTES.CART);
    }
  };

  setCart = async (cart) => {
    await this.setState({ cart, showModal: true });
  };

  setCopyCartCanceled = async (cartId) => {
    await this.setState({ cartId, showModalCanceled: true });
  };

  copyCartCanceled = async () => {
    const { cartId } = this.state;
    await this.setState({ cartId: null, showModalCanceled: false });
    await this.props.copyCartCanceled(cartId);
    history.push(ROUTES.CART);
  };

  renderModalSelectCart = showModal => (
    <div
      className="modal"
      style={{ display: showModal ? 'block' : 'none' }}
      onClick={() => {
        this.setState({ showModal: false, cart: null });
      }}
      role="presentation"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text">
            <h3 className="h3-modal-div">{I18n.t('wishToApproveCart')}</h3>
            <h4 className="h4-modal-div">{I18n.t('currentCartWillChange')}</h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn btn-grey"
              onClick={() => this.setState({ showModal: false, cart: null })}
            >
              {I18n.t('cancel')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => this.selectCart()}
            >
              {I18n.t('visualizeCart')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  renderModalCopyCartCanceled = showModalCanceled => (
    <div
      className="modal"
      style={{ display: showModalCanceled ? 'block' : 'none' }}
      onClick={() => {
        this.setState({ showModalCanceled: false, cartId: null });
      }}
      role="presentation"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text">
            <h3 className="h3-modal-div">{I18n.t('wishToApproveCart')}</h3>
            <h4 className="h4-modal-div">{I18n.t('currentCartWillChange')}</h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn btn-grey"
              onClick={() => this.setState({ showModalCanceled: false, cartId: null })
              }
            >
              {I18n.t('cancel')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => this.copyCartCanceled()}
            >
              {I18n.t('copyOrder')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  renderCartApproveModal = (showModalApprove, multi) => (
    <div
      className="modal"
      style={{ display: showModalApprove ? 'block' : 'none' }}
      onClick={() => {
        this.setState({ showModalApprove: false, multi: false, cart: null });
      }}
      role="presentation"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text">
            <h3 className="h3-modal-div">
              {multi ? I18n.t('approveCarts') : I18n.t('approveCart')}
            </h3>
            <h4 className="h4-modal-div">
              {multi ? I18n.t('approveCartsInfo1') : ''}
            </h4>
            <h4 className="h4-modal-div">
              {multi
                ? I18n.t('approveCartsConfirm')
                : I18n.t('approveCartConfirm')}
            </h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn btn-grey"
              onClick={() => this.setState({
                showModalApprove: false,
                multi: false,
                cart: null,
              })
              }
            >
              {I18n.t('cancel')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => (multi ? this.approveAll() : this.approveCart())}
            >
              {I18n.t('approve')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  renderCartReproveModal = (showModalReprove, multi) => (
    <div
      className="modal"
      style={{ display: showModalReprove ? 'block' : 'none' }}
      onClick={() => {
        this.setState({ showModalReprove: false, cart: null });
      }}
      role="presentation"
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="column body-modal-text">
            <h3 className="h3-modal-div">
              {multi ? I18n.t('declineCarts') : I18n.t('declineCart')}
            </h3>
            <h4 className="h4-modal-div">
              {multi
                ? I18n.t('declineCartsConfirm')
                : I18n.t('declineCartConfirm')}
            </h4>
          </div>
          <div className="row body-modal-div">
            <button
              type="button"
              className="btn btn-grey"
              onClick={() => this.setState({
                showModalReprove: false,
                multi: false,
                cart: null,
              })
              }
            >
              {I18n.t('cancel')}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => (multi ? this.reproveAll() : this.removeCart())}
              style={{ backgroundColor: '#b93744' }}
            >
              {I18n.t('decline')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  renderCartInfos = (cart, type, cartId, copyCartCanceledF, setCartF) => {
    const { productsWithProblem } = cart;
    const isDisabled = productsWithProblem && productsWithProblem.length > 0;

    if (type === 'canceled') {
      return (
        <button
          type="button"
          className="btn"
          onClick={() => copyCartCanceledF(cartId)}
        >
          {I18n.t('copyOrder')}
        </button>
      );
    }
    return (
      <React.Fragment>
        {!cart.selected && (
          <React.Fragment>
            {cart.hasLimit ? (
              <React.Fragment>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({
                    cart,
                    showModalReprove: true,
                    multi: false,
                  })
                  }
                  style={{ backgroundColor: '#b93744' }}
                >
                  {I18n.t('decline')}
                </button>
                {cart.cartToApprove ? (
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.setState({
                      cart,
                      showModalApprove: true,
                      multi: false,
                    })
                    }
                    style={{
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      opacity: isDisabled ? 0.5 : 1,
                    }}
                    disabled={isDisabled}
                  >
                    {I18n.t('approve')}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn"
                    style={{
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      opacity: isDisabled ? 0.5 : 1,
                    }}
                    onClick={() => setCartF(cart)}
                    disabled={isDisabled}
                  >
                    {I18n.t('visualizeCart')}
                  </button>
                )}
              </React.Fragment>
            ) : (
              <div className="error-msg">{I18n.t('limitCartWarning')}</div>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  setCheckbox = (cart, selected) => {
    const { carts } = this.state;

    const newCarts = carts.map((newCart) => {
      if (newCart.cartId === cart.cartId) newCart.selected = selected;
      return newCart;
    });

    this.setState({ carts: newCarts });
  };

  checkAll = (check) => {
    const { carts } = this.state;

    const newCarts = carts.map((newCart) => {
      if (
        !newCart.productsWithProblem
        || newCart.productsWithProblem.length === 0
      ) {
        newCart.selected = check;
      }
      return newCart;
    });

    this.setState({ carts: newCarts });
  };

  showReproveAll = () => {
    const { carts } = this.state;

    const selected = carts.filter(cart => cart.selected);

    if (selected && selected.length > 0) {
      this.setState({ showModalReprove: true, multi: true });
    }
  };

  reproveAll = async () => {
    const { carts } = this.state;

    const selected = carts.filter(cart => cart.selected);

    if (selected && selected.length > 0) {
      const cartIds = selected.map(cart => cart.cartId);
      await this.props.reproveCartAll(cartIds);
      await this.loadCarts(null);
    }
  };

  showApproveAll = () => {
    const { carts } = this.state;

    const selected = carts.filter(cart => cart.selected);

    if (selected && selected.length > 0) {
      this.setState({ showModalApprove: true, multi: true });
    }
  };

  approveAll = async () => {
    const { carts } = this.state;
    const { clientId } = this.props;

    const selected = carts.filter(cart => cart.selected);

    if (selected && selected.length > 0) {
      const cartsToApprove = selected.map((cart) => {
        const { taxType, companyTag } = this.props;

        const items = cart.products.map(item => ({
          total: item.quantity,
          product: item,
        }));

        const subTotal = CartUtils.getCartTotal(
          items,
          true,
          undefined,
          undefined,
          companyTag,
        );
        const tax = CartUtils.getCartTax(items, taxType, undefined, companyTag);
        const total = (subTotal + tax).toFixed(2);

        return { cartId: cart.cartId, total };
      });

      try {
        await this.props.approveCartAll(cartsToApprove, clientId);
      } catch (err) {
        if (
          err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error.code === 1616
        ) {
          Swal.fire({
            titleText: I18n.t('attention'),
            text: I18n.t('userHasNoPriceContract'),
            icon: 'error',
          });
          return;
        }
        if (
          err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error.code === 1617
        ) {
          Swal.fire({
            titleText: I18n.t('attention'),
            text: I18n.t('userHasNoPriceSpotPermission'),
            icon: 'error',
          });
          return;
        }
        if (
          err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error.code === 1620
        ) {
          Swal.fire({
            titleText: I18n.t('attention'),
            text: I18n.t('productsWrongPrince', {
              0: err.response.data.error.details,
            }),
            icon: 'error',
          });
          return;
        }
      }
      await this.loadCarts(null);
    }
  };

  renderCartsToApproveCart = ({
    key,
    cart = {},
    pricePermission,
    setCart,
    copyCartCanceledF,
  }) => {
    const {
      products = [],
      cartId,
      type,
      selected = false,
      user,
      productsWithProblem,
    } = cart;

    const isDisabled = productsWithProblem && productsWithProblem.length > 0;

    return (
      <div className="requests-item" key={key}>
        <div
          className={`date${
            !cart.hasLimit || type === 'canceled' ? ' not-allow' : ''
          }`}
        >
          <svg className="icon icon-cart2">
            <use xlinkHref="#icon-cart2" />
          </svg>
          <span className="nome">{user.name}</span>
          <span className="email">{user.email}</span>
        </div>
        <div className="content">
          <span className="content-item">
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <strong>
                {I18n.t('code')}
                {cartId}
              </strong>
              {cart.hasLimit ? (
                <input
                  className="ckb"
                  type="checkbox"
                  style={{
                    height: '15px',
                    width: '15px',
                    outline: 'auto',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }}
                  checked={selected}
                  onChange={e => this.setCheckbox(cart, e.target.checked)}
                  disabled={isDisabled}
                />
              ) : null}
            </div>
            {products.map(product => (
              <p style={{ marginTop: 4 }} key={product.id}>
                {'- '}
                {product.quantity}
                {' x '}
                {product.name}
                {pricePermission && ' - '}
                {pricePermission && (
                  <strong>
                    <PriceComponent value={Number(product.price.value) || 0} />
                  </strong>
                )}
              </p>
            ))}
          </span>

          {productsWithProblem && productsWithProblem.length > 0 && (
            <div>
              <p style={{ marginTop: 4, color: 'red' }}>
                {I18n.t('productsWithProblem')}
              </p>
              {productsWithProblem.map(product => (
                <p style={{ marginTop: 4, color: 'red' }} key={product.id}>
                  {product.productId}
                </p>
              ))}
            </div>
          )}
          <div className="content-footer">
            <div className="btns">
              {this.renderCartInfos(
                cart,
                type,
                cartId,
                copyCartCanceledF,
                setCart,
              )}
            </div>
            {pricePermission && <PriceTaxComponent products={products} />}
          </div>
        </div>
      </div>
    );
  };

  calculateTotal = (carts) => {
    const { taxType, companyTag } = this.props;

    const totalPending = carts.reduce((total, cart) => {
      const items = cart.products.map(item => ({
        total: item.quantity,
        product: item,
      }));

      const subTotal = CartUtils.getCartTotal(
        items,
        true,
        undefined,
        undefined,
        companyTag,
      );
      const tax = CartUtils.getCartTax(items, taxType, undefined, companyTag);
      return total + subTotal + tax;
    }, 0);

    return totalPending;
  };

  render() {
    const {
      carts = [],
      showModal,
      showModalCanceled,
      showModalApprove,
      showModalReprove,
      multi,
    } = this.state;
    const { pricePermission, cartUsersPermission } = this.props;

    if (!cartUsersPermission) return null;

    const totalPending = this.calculateTotal(carts);

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('cartToApproveTwo')}</h1>

            <div className="panel-content">
              <PanelSidebar />

              <div className="box-content requests">
                <div className="requests-header">
                  <div className="filter">
                    <label>
                      {I18n.t('filterBy')}
                      <div className="select select--white">
                        <select
                          name="filterBy"
                          value={this.state.filterBy}
                          onChange={e => this.loadCarts(e.target.value)}
                        >
                          {Object.keys(purchaseData.cartOrderTypes).map(
                            (item, index) => (
                              <option
                                key={`${purchaseData.cartOrderTypes[item].label}${index}`}
                                value={purchaseData.cartOrderTypes[item].value}
                              >
                                {I18n.t(
                                  purchaseData.cartOrderTypes[item].label,
                                )}
                              </option>
                            ),
                          )}
                        </select>
                      </div>
                    </label>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-grey"
                      onClick={() => this.checkAll(false)}
                      style={{ marginBottom: '10px' }}
                    >
                      {I18n.t('unmarkAll')}
                    </button>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => this.checkAll(true)}
                    >
                      {I18n.t('markAll')}
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => this.showReproveAll()}
                      style={{
                        backgroundColor: '#b93744',
                        marginBottom: '10px',
                      }}
                    >
                      {`${I18n.t('decline')} ${I18n.t('selected')}`}
                    </button>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => this.showApproveAll()}
                    >
                      {`${I18n.t('approve')} ${I18n.t('selected')}`}
                    </button>
                  </div>
                  <div>
                    <span
                      style={{
                        color: '#545454',
                        fontWeight: 700,
                        lineHeight: '16px',
                        display: 'block',
                        marginTop: '20px',
                      }}
                    >
                      {'Total Carrinhos Pendentes'}
                      {': '}
                      {` ${carts.length}`}
                    </span>
                  </div>
                  <div>
                    <span
                      style={{
                        color: '#545454',
                        fontWeight: 700,
                        lineHeight: '16px',
                        display: 'block',
                        marginTop: '20px',
                      }}
                    >
                      {'Total Valores Pendentes'}
                      {': '}
                      <PriceComponent value={totalPending} force />
                    </span>
                  </div>
                </div>

                {carts.map(cart => this.renderCartsToApproveCart({
                  key: cart.cartId,
                  cart,
                  pricePermission,
                  setCart: this.setCart,
                  copyCartCanceledF: this.setCopyCartCanceled,
                }))}
              </div>
            </div>
          </div>
          {this.renderModalSelectCart(showModal)}
          {this.renderModalCopyCartCanceled(showModalCanceled)}
          {this.renderCartApproveModal(showModalApprove, multi)}
          {this.renderCartReproveModal(showModalReprove, multi)}
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCarts: filterBy => dispatch(cartsGetListToApprove(filterBy)),
  removeCart: cartId => dispatch(cartApproveRemove(cartId)),
  approveCart: cartId => dispatch(cartApproveApprove(cartId)),
  selectCart: (cart, cartId, user, cartAddressInformation) => dispatch(cartApproveSelect(cart, cartId, user, cartAddressInformation)),
  copyCartCanceled: cartId => dispatch(copyCartCanceled(cartId)),
  approveCartAll: (cartsToApprove, clientId) => dispatch(approveCartAll(cartsToApprove, clientId)),
  reproveCartAll: cartIds => dispatch(reproveCartAll(cartIds)),
  selectContract: index => dispatch(selectContract(index)),
});

const mapStateToProps = state => ({
  user: state.auth && state.auth.user,
  clientId: state.contracts.selected.client.id,
  pricePermission:
    state.contracts.selected && state.contracts.selected.pricePermission,
  cartUsersPermission:
    state.contracts.selected && state.contracts.selected.cartUsersPermission,
  taxType: state.settings && state.settings.taxType,
  taxesCart: state.settings && !state.settings.taxsCartOff,
  companyTag: state.settings && state.settings.companyTag,
  contracts: state.contracts,
  contractSelected: state.contracts.selected,
});

export default connect(mapStateToProps, mapDispatchToProps)(cartsToApprovePage);
